
import {
    get,
    post,
    del
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增信息发布
export function addTheInformationRelease(params) {
    return post(`${HOST}the-information-release/save`, params)
}
// 修改信息发布
export function updateTheInformationRelease(params) {
    return post(`${HOST}the-information-release/update`, params)
}
//信息发布列表
export function getTheInformationRelease(params) {
    return get(`${HOST}the-information-release/list/`, params)
}
//信息发布草稿箱列表
export function TheInformationReleaseDraftlist(params) {
    return get(`${HOST}the-information-release/draftlist`, params)
}
//信息发布详情
export function TheInformationReleaseDetial(params) {
    return get(`${HOST}the-information-release/get`, params)
}
// 删除信息发布
export function delTheInformationRelease(params) {
    return del(`${HOST}the-information-release/delete`, params)
}







// WEBPACK FOOTER //
// ./src/views/InformationPublish/api/api.js